import React from 'react';

interface PropertyRowProps {
  icon?: React.ReactNode;
  label: string;
  /** Valore leggibile a riposo. */
  value: React.ReactNode;
  /** Nota grigia dopo il valore (es. "· da anagrafica"). */
  aside?: React.ReactNode;
  /** Testo dell'azione fantasma che appare in hover. Null = riga non cliccabile. */
  action?: string | null;
  onClick?: () => void;
  /** Contenuto espanso sotto la riga (selettore, campi). */
  children?: React.ReactNode;
  expanded?: boolean;
}

/**
 * Riga proprietà del pannello riga servizio: etichetta a sinistra a larghezza
 * fissa, valore a destra, azione fantasma in hover. Ripresa dal drawer
 * Nota/Attività, dove una proprietà si legge sempre e si apre solo al click.
 */
export function PropertyRow({
  icon,
  label,
  value,
  aside,
  action = 'cambia',
  onClick,
  children,
  expanded = false,
}: PropertyRowProps) {
  const interactive = !!onClick;

  return (
    <div>
      <button
        type="button"
        onClick={onClick}
        disabled={!interactive}
        aria-expanded={children ? expanded : undefined}
        className={`w-full flex items-center min-h-[30px] px-2 py-1 -mx-2 rounded text-left transition-colors ${
          interactive ? 'hover:bg-black/[0.03] dark:hover:bg-white/[0.04] group cursor-pointer' : 'cursor-default'
        }`}
      >
        <span className="flex items-center gap-1.5 w-[152px] flex-shrink-0 text-[12px] font-medium text-black/55 dark:text-white/55">
          {icon}
          {label}
        </span>
        <span className="flex-1 min-w-0 text-[13px] text-black dark:text-white truncate tabular-nums">
          {value}
          {aside != null && (
            <span className="text-black/40 dark:text-white/40 text-[12px]"> {aside}</span>
          )}
        </span>
        {interactive && action && (
          <span className="ml-auto flex-shrink-0 text-[11px] text-black/50 dark:text-white/50 opacity-0 group-hover:opacity-100 transition-opacity">
            {action}
          </span>
        )}
      </button>
      {children && expanded && <div className="pl-[152px] pb-1">{children}</div>}
    </div>
  );
}
